import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ProjectWindowStore, ProjectWindowState } from './project-window.store';

@Injectable()
export class ProjectWindowQuery extends Query<ProjectWindowState> {
	punchListId$ = this.select(state => state.punchListId);

	constructor(protected store: ProjectWindowStore) {
		super(store);
	}
}